import React, { useState } from 'react';
import Navbar from './Navbar';

const HamburgerIcon = () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
        <line x1="3" y1="6"  x2="21" y2="6"  />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
);

const Layout = ({ children, onLogout }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const close = () => setSidebarOpen(false);

    return (
        <div className="fb-layout">
            {/* ── Mobile top bar ── */}
            <div className="fb-mobile-bar">
                <button
                    className="fb-hamburger"
                    onClick={() => setSidebarOpen(o => !o)}
                    aria-label="Open menu"
                >
                    <HamburgerIcon />
                </button>
                <span className="fb-mobile-brand">FOBASE</span>
            </div>

            {/* ── Backdrop (mobile only) ── */}
            <div
                className={`fb-overlay${sidebarOpen ? ' fb-overlay--visible' : ''}`}
                onClick={close}
            />

            {/* ── Sidebar / nav ── */}
            <Navbar
                onLogout={onLogout}
                isOpen={sidebarOpen}
                onNavClick={close}
            />

            {/* ── Page content ── */}
            <main className="fb-main">
                <div className="fb-content">{children}</div>
            </main>
        </div>
    );
};

export default Layout;
